export enum WebAppEvent {
  CustomOrder = "custom_order",
  IntermediaryOrder = "intermediary_order",
  ProductOrder = "product_order",
  ConsultOrder = "consult_order",
}
